"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { LoginMethodTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useEffect, useState } from "react";
import SocialButtons from "../auth-common/auth-social/SocialButtons";
import AuthTabs from "../auth-common/auth-tabs/AuthTabs";
import AuthContainer from "../auth-common/auth-container/AuthContainer";
import AuthRedirectTo from "../auth-common/AuthRedirectTo";
import SignInForm from "./SignInForm";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useSearchParams } from "next/navigation";
import { useLogout } from "@/hooks/useLogout";

const SignIn: React.FC<{
  isFromCheckout?: boolean;
  onClickBack?: () => void;
  setTab?: () => void;
}> = ({ isFromCheckout, onClickBack, setTab }) => {
  const searchParams = useSearchParams();
  const { logout } = useLogout();
  const getCompany = useGetCompanyQuery();
  const company = getCompany?.data?.result;
  const customer_login_methods =
    company?.theme?.settings?.customer_login_methods;
  const t = useTranslation();
  const [btnIndex, setBtnIndex] = useState<LoginMethodTypes>();
  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isFromCart = searchParams.get("fromCart");
  const goToAuthFromPage = (from?: "fromCart" | "fromCheckout") => {
    if (!from) return "";
    const params = new URLSearchParams(searchParams.toString());
    params.set(from, "true");
    return "?" + params.toString();
  };
  const href =
    PagesPaths.register +
    goToAuthFromPage(
      isFromCart ? "fromCart" : isFromCheckout ? "fromCheckout" : undefined,
    );
  return (
    <AuthContainer
      title={t.sign_in}
      isFromCheckout={isFromCheckout}
      onClickBack={onClickBack}
    >
      {[LoginMethodTypes.any, LoginMethodTypes.both].includes(
        customer_login_methods!,
      ) ? (
        <AuthTabs btnIndex={btnIndex} setBtnIndex={setBtnIndex} />
      ) : (
        <></>
      )}
      <SignInForm
        registerBy={btnIndex ?? customer_login_methods}
        isFromCheckout={isFromCheckout}
      />
      <SocialButtons />
      <AuthRedirectTo
        text={t["don't_have_account"]}
        authLink={{
          text: t.register,
          href,
        }}
        onClick={setTab}
      />
    </AuthContainer>
  );
};

export default SignIn;
